export const PRODUCT_DETAILS_REPOSITORY = Symbol.for('PRODUCT_DETAILS_REPOSITORY');
export const PRODUCT_DETAILS_AVAILABILITY_REPOSITORY = Symbol.for('PRODUCT_DETAILS_AVAILABILITY_REPOSITORY');
